import get from 'lodash/get'
import isNil from 'lodash/isNil'

import * as PoziUtils from 'api/utils'

export default function (olLayer, attributions, forceShow = false) {
  if (isNil(olLayer)) {
    return
  }

  const layer = PoziUtils.getLayerFromOLLayer(olLayer)
  if (isNil(layer)) {
    return
  }

  // Only set attributions for basemaps unless force is true
  if (layer.groupid !== 'basemap' && !forceShow) {
    return
  }

  const source = olLayer.getSource ? olLayer.getSource() : null
  if (isNil(source) || isNil(source.setAttributions)) {
    return
  }

  const title = get(layer, 'title', '')
  const aboutUrl = get(layer, 'about.url', '')

  if (!aboutUrl && !title && (!attributions || attributions.length === 0)) {
    return
  }

  const defaultAttributionString = `
    <a target="_blank" rel="noopener noreferrer" href="${aboutUrl}">${title}</a>`

  source.setAttributions(attributions || [defaultAttributionString])
}
